<div class="tt-compare-flowchart-dialog_content">
  <tt-flowchart
    ttColorCustomisations
    [allowEvents]="false"
    [customisation]="organisationSettings().customisations?.flowchart"
    [flowchartElements]="data.flowchartElements"
    [flowchartId]="data.id"
    [fullScreen]="true" />
</div>

<div class="tt-compare-flowchart-dialog_footer">
  <button ttButton [variant]="'primary'" (click)="dialogRef.close()">{{ 'Close' | transloco }}</button>
</div>
